<template>
    <div class="interface-simplified-redirector">

        <v-progress-circular
            v-if="inTransitInFlight"
            class="loader"
            color="primary"
            size="100"
            width="5"
            indeterminate
        />

        <div
            v-else
            class="nothing-to-deliver"
        >
            <v-icon class="nothing-to-deliver__icon-clock">
                mdi-clock-outline
            </v-icon>
            <div class="nothing-to-deliver__text">
                <p>Nothing is ready for Delivery.</p>
                <p>Check back later.</p>
            </div>
        </div>

    </div>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'InterfaceSimplifiedRedirector',
    computed: {
        ...mapGetters( {
            hasInTransitList: 'Mail/Delivery/hasInTransitList',
        } ),
        ...mapState( {
            inTransitInFlight: ( state ) => state.Mail.Delivery.inTransit.inFlight,
            lastCheck: ( state ) => state.Mail.Delivery.inTransit.lastCheck,
        } ),
    },
    watch: {
        hasInTransitList() {
            if ( this.hasInTransitList ) {
                this.goToTransitPage();
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // If it has been more than 5 seconds since the last check, look for inTransitDeliveries
            if ( ( new Date() ).getTime() > ( this.lastCheck + 5000 ) ) {
                await this.$store.dispatch( 'Mail/Delivery/getInTransitDeliveries' );
                this.goToTransitPage();
            }
        },
        goToTransitPage() {
            this.$router.push( { path: '/mail/delivery/transit' } )
                .catch( ( error ) => {
                    // SHUT UP VUE-ROUTER - THIS ISN'T AN ERROR, IT'S A FEATURE!
                    if ( error && error.name && ( error.name !== 'NavigationDuplicated' ) ) console.error( 'Navigation Error: ', error );
                } );
        },
    },
};
</script>

<style scoped lang="scss">
.interface-simplified-redirector {
    height: 50vh;
    display: flex;
    flex-flow: row nowrap;
}

.loader {
    display: flex;
    flex-flow: row nowrap;
    margin: auto;
}

.nothing-to-deliver {
    display: flex;
    flex-flow: row nowrap;
    margin: auto;

    &__icon-clock {
      font-size: 120px;
    }

    &__text {
        display: flex;
        flex-flow: column nowrap;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 1rem;
    }
}
</style>
